import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _objectDestructuringEmpty from "/home/prasanta/Projects/get-mutual-transfer-website/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty";
import Head from "next/head";
import React from "react";
import RailwayStaffSearchPage from "../../../src/pages/RailwayStaffSearchPage/RailwayStaffSearchPage";
export default function Primary(_ref) {
  _objectDestructuringEmpty(_ref);

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Head, {
      children: /*#__PURE__*/_jsx("title", {
        children: "Railway Staff Search | Get Mutual Transfer"
      })
    }), /*#__PURE__*/_jsx(RailwayStaffSearchPage, {})]
  });
}